import styled, { css } from 'styled-components';

const stickyStyles = css`
  position: sticky;
  ${({ left }) => (left ? 'left: 0;' : 'top: 0;')}
  background-color: var(--background-color);
  z-index: 1;
`;

export const StickyTh = styled.th`
  ${stickyStyles}
  ${({ $small, $isLineTable }) =>
    $isLineTable
      ? $small
        ? 'min-width: 100px;'
        : 'min-width: var(--table-column-width);'
      : ''}
`;
export const StickyTd = styled.td`
  ${stickyStyles}
`;
